import { Layers } from "lucide-react";
import { eur } from "./format";

const COLORS = {
  Artwork: "#94a3b8", Prepress: "#38bdf8", Digital: "#22d3ee", Litho: "#60a5fa", "Wide Format": "#a78bfa",
  Outwork: "#f472b6", Finishing: "#fbbf24", Packaging: "#fb923c", Dispatch: "#34d399", Invoicing: "#f59e0b", Other: "#64748b",
};

const slug = (s) => s.replace(/\s+/g, "-").toLowerCase();

export const DepartmentPanel = ({ departments }) => {
  const total = departments.reduce((s, d) => s + d.count, 0);
  const max = Math.max(1, ...departments.map((d) => d.count));
  return (
    <div className="min-w-0 rounded-2xl bg-slate-900/70 ring-1 ring-white/5" data-testid="department-panel">
      <div className="flex items-start justify-between gap-3 border-b border-white/5 p-5">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">Jobs by department</p>
          <p className="mt-0.5 text-sm text-slate-500">Live PrintLogic jobs by current status · workflow order</p>
        </div>
        <span className="flex items-center gap-1.5 rounded-full bg-sky-500/15 px-3 py-1 font-mono text-sm font-bold text-sky-300 ring-1 ring-sky-500/30" data-testid="department-total">
          <Layers className="h-4 w-4" /> {total}
        </span>
      </div>
      <ul className="divide-y divide-white/5" data-testid="department-list">
        {departments.map((d) => {
          const color = COLORS[d.department] || COLORS.Other;
          const breakdown = Object.entries(d.statuses).sort((a, b) => b[1] - a[1]).map(([s, n]) => `${s}: ${n}`).join(" · ");
          return (
            <li key={d.department} className={`px-5 py-3 ${d.count === 0 ? "opacity-50" : ""}`} data-testid={`department-row-${slug(d.department)}`} title={breakdown || "No live jobs"}>
              <div className="flex items-center justify-between gap-3 text-sm">
                <span className="flex items-center gap-2 font-semibold text-slate-100">
                  <span className="h-2.5 w-2.5 rounded-sm" style={{ backgroundColor: color }} />{d.department}
                  {d.invoiced > 0 && (
                    <span className="rounded-full bg-emerald-500/15 px-2 py-0.5 text-[11px] font-semibold text-emerald-300 ring-1 ring-emerald-500/30" data-testid={`department-invoiced-${slug(d.department)}`}>
                      {d.invoiced} invoiced
                    </span>
                  )}
                </span>
                <span className="flex items-baseline gap-3">
                  <span className="font-mono text-xs text-slate-500">{eur(d.value)}</span>
                  <span className="font-mono text-xl font-bold text-slate-50" data-testid={`department-count-${slug(d.department)}`}>{d.count}</span>
                </span>
              </div>
              <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-slate-800">
                <div className="h-full rounded-full transition-[width] duration-500" style={{ width: `${(d.count / max) * 100}%`, backgroundColor: color }} />
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
